<script>
export default {
    name: "InpatientProgressNotes",

    data() {

        return {
            patients: [],
        };
    },

    mounted() {

        Promise.allSettled([ this.fetchPatients(), ]).then(() => { 
            window.print();
        }).catch(() => {});
    },

    methods: {

        fetchPatients() {
            let url = `Inpatient/GetInpatientProgressNotes`;
      url += `?Datefrom=${this.$route.query.dateFrom}&Dateto=${this.$route.query.dateTo}`;
                url += this.$route.query.search ? `&SearchText=${this.$route.query.search}` : ``;
                url += this.$route.query.floorId ? `&FloorId=${this.$route.query.floorId}` : `&FloorId=0`;
                url += `&Hasnotes=${this.$route.query.hasnotes}`;
                // let url = `PatientReports/GetTBScreenings?Datefrom=${this.$route.query.dateFrom}&Dateto=${this.$route.query.dateTo}`;
             
            return this.$http.get(url).then(response => {
                    this.patients = response.data;
                }).catch(() => {});
        },
      
    },
}
</script>
<template>
    <div class="flex flex-wrap">
        <div class="w-full my-2 text-center">
            <h5 class="font-medium">Progress Notes Report</h5>
        </div>
            <table class="table table-striped">
                <thead class="text-sm">
                      <tr class="w-full flex">
                        <th class="p-tiny flex-1">Date</th>
                  <th class="p-tiny w-1/6">Name</th>
                  <th class="p-tiny flex-1">Personal Details</th>
                  <th class="p-tiny flex-1">Admitted On</th>
                  <th class="p-tiny flex-1">Days</th>
                  <th class="p-tiny flex-1">Ward</th>
                  <th class="p-tiny flex-1">Bed</th>
                  <th class="p-tiny w-1/5">PMode</th>
                      </tr>
                </thead>
                <tbody class="text-xs flex flex-col items-center">
                    <!-- <tr class="w-full flex" v-for="(patient, idx) in patients" :key="idx">
                        <td class="p-tiny w-1/6">{{ patient.names }}</td>
                        <td class="p-tiny w-1/12">{{ patient.ipfileno }}</td>
                        <td class="p-tiny w-1/12">{{ patient.type }}</td>
                        <td class="p-tiny w-1/12">{{ patient.dateAdmitted | dateFormat }}</td>
                        <td class="p-tiny w-1/12">{{ patient.discharged ? `Yes` : `No` }}</td>
                        <td class="p-tiny w-1/12">{{ patient.ward }}</td>
                        <td class="p-tiny w-1/12">{{ patient.bed }}</td>
                        <td class="p-tiny w-1/12">{{ patient.days }}</td>
                        <td class="p-tiny w-1/12">{{ patient.approvedBy }}</td>
                        <td class="p-tiny w-1/6">{{ patient.pmode }}</td>
                    </tr> -->
                    <tr
                  class="flex w-full" 
                  v-for="(pat, idx) in patients"
                  :key="idx"
                   
                >  <td class="p-tiny flex-1">
                    {{ pat.date | dateFormat }}
                  </td>
                  <td class="p-tiny w-1/6">
                    <h5 class="text-sm leading-5 font-bold text-gray-900">
                      {{ pat.names }}
                    </h5>
                    <h5 class="text-xs leading-5 text-gray-700">
                      <span class="mr-2">
                          MRN: {{ pat.patienT_ID || `-` }} </span>
                          <span>IP: {{ pat.ipfileno }}</span>
                    </h5>
                    <h5 class="text-xs leading-5 text-gray-700">
                      DOB: {{ pat.dob | dateFormat }}
                    </h5>
                    <h5 class="text-xs leading-5 text-gray-700">
                      Gender: {{ pat.gender }}
                    </h5>
                  </td>
                  <td class="p-tiny flex-1">
                      <h5 class="text-xs">ID No: {{ pat.nationalid }}</h5>
                      <h5 class="text-xs">CellPhone: {{ pat.celL_PHONE || `-` }}</h5>
                  </td>
                  <td class="p-tiny flex-1">
                    {{ pat.dateAdmitted | dateFormat }}
                  </td>
                  <td class="p-tiny flex-1">{{ pat.days }}</td>
                  <td class="p-tiny flex-1">{{ pat.ward }}</td>
                  <td class="p-tiny flex-1">{{ pat.bed }}</td>
                  <td class="p-tiny w-1/5 break-words">{{ pat.pMode }}</td>
                   
                </tr>
                    <tr class="w-full flex">
                        <td class="w-1/2 p-tiny"></td>
                        <td class="w-1/2 p-tiny text-right">Total Patients: {{ patients.length }}</td>
                    </tr>
                </tbody>
            </table>
    </div>
</template>